<template>
  <div class="home">
    <Navbar id="navbar"></Navbar>
    <div class="container">
    <Holdingtable id="holdingtable"></Holdingtable>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//test comment 2
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');
import HelloWorld from '@/components/HelloWorld.vue'
import Navbar from '@/components/Navbar'
import Holdingtable from '@/components/Holdingtable'

export default {
  name: 'home',
  components: {
    HelloWorld,
    Navbar,
    Holdingtable
  },
  methods:{
    logout: function(){
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  }
}
</script>

<style>
#navbar {
  margin-bottom: 80px;
}

</style>
